import { Progress, TabBar } from "d-react-components";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EquipmentStockAdjustmentAPI from "../../../../api/queries/equipment-stock-adjustment";
import { EquipmentStockAdjustmentDetailContext } from "../../../../context/equipment-stock-adjustment";
import Messages from "../../../../languages/Messages";
import EquipmentStockAdjustmentActivity from "./EquipmentStockAdjustmentActivity";
import EquipmentStockAdjustmentHeader from "./EquipmentStockAdjustmentHeader";
import EquipmentStockAdjustmentSummary from "./EquipmentStockAdjustmentSummary";
import EquipmentStockAdjustmentGeneral from "./EquipmentStockAdjustmentGeneral";
import EquipmentStockAdjustmentItems from "./EquipmentStockAdjustmentItems";

const TABS = [
    {
        id: "general",
        label: Messages.generalInformation,
        component: <EquipmentStockAdjustmentGeneral />,
    },
    {
        id: "service",
        label: Messages.items,
        component: <EquipmentStockAdjustmentItems />,
    },
    {
        id: "activity",
        label: Messages.activity,
        component: <EquipmentStockAdjustmentActivity />,
    },
];

const EquipmentStockAdjustmentDetail = () => {
    const { stockAdjustmentId } = useParams<any>();
    const [stockAdjustment, setStockAdjustment] = useState<any>();
    const [tab, setTab] = useState(TABS[0]);

    useEffect(() => {
        loadDetailData();
    }, []);

    const loadDetailData = () => {
        Progress.show(
            {
                method: EquipmentStockAdjustmentAPI.detail,
                params: [stockAdjustmentId],
            },
            setStockAdjustment as any
        );
    };

    if (!stockAdjustment) {
        return <div />;
    }

    return (
        <EquipmentStockAdjustmentDetailContext.Provider
            value={{ stockAdjustment, setStockAdjustment }}
        >
            <div className="flex-column-container bg-white">
                <EquipmentStockAdjustmentHeader />
                <div className="px-4 py-3">
                    <div className="grid grid-cols-4 gap-4">
                        <div className="col-span-1">
                            <EquipmentStockAdjustmentSummary />
                        </div>
                        <div className="col-span-3">
                            <TabBar
                                dataSource={TABS}
                                onChange={setTab as any}
                                value={tab}
                            />
                            <div className="bg-white mt-3">{tab.component}</div>
                        </div>
                    </div>
                </div>
            </div>
        </EquipmentStockAdjustmentDetailContext.Provider>
    );
};

export default EquipmentStockAdjustmentDetail;
